import { render } from "./NextButton.vue?vue&type=template&id=17ad32fa&scoped=true&ts=true"
import script from "./NextButton.vue?vue&type=script&lang=ts"
export * from "./NextButton.vue?vue&type=script&lang=ts"

import "./NextButton.vue?vue&type=style&index=0&id=17ad32fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ad32fa"]])

export default __exports__